import { AxiosResponse } from "axios";
import { authRequest } from "common/src/utils/request";

/** 契約情報 */
export type kei01p = {
  /** 契約者郵便番号 */
  tfKekyyn?: string;
  /** 契約者住所1 */
  tfKekya1?: string;
  /** 契約者住所2 */
  tfKekya2?: string;
  /** 契約者住所3 */
  tfKekya3?: string;
  /** 契約者電話番号 */
  tfKekytl?: string;
  /** 契約者電話番号（携帯） */
  tfKekyt2?: string;
  /** 変更日時 */
  tfKehkdt?: number;
};

/**
 * API0440 契約情報変更 リクエストインターフェース
 */
export type contractChangeRequest = {
  kei01p: kei01p;
};

/**
 * API0440 契約情報変更
 * @returns
 */
export const postContractChange = async (req: contractChangeRequest): Promise<AxiosResponse> => {
  return await authRequest.post("/v1/user/contracts", req);
};
